import TilesetMenu from './TilesetMenu';
import { isLandUseTileset } from '../../utils/tilesets';
import { TILESET_TYPE_ATTRIBUTE } from '../../types/tileset';

export const LAND_USE_LAYER_ID = 'land-use';

const LandUseLayerMenu = () => (
  <TilesetMenu
    filterTilesets={isLandUseTileset}
    title="Historical Land Use"
    type={TILESET_TYPE_ATTRIBUTE}
  />
);

export default LandUseLayerMenu;
